import { render } from "./AppBasicTable.vue?vue&type=template&id=8f4afbca&scoped=true"
import script from "./AppBasicTable.vue?vue&type=script&lang=js"
export * from "./AppBasicTable.vue?vue&type=script&lang=js"

import "./AppBasicTable.vue?vue&type=style&index=0&id=8f4afbca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f4afbca"]])

export default __exports__